import { TrainQualityPreset } from "@/components/pages/custom/hooks/use-create-custom";
import StyledDropdown from "@/components/common/styled-dropdown";
import { useState } from "react";

type DropdownProps = {
  presets: TrainQualityPreset[];
  selectedPreset: TrainQualityPreset;
  handlePresetChanged: (value: TrainQualityPreset) => void;
};

const QualityPresetDropdown = ({
  presets,
  selectedPreset,
  handlePresetChanged,
}: DropdownProps) => {
  const [presetsMap, setPresetsMap] = useState(
    Object.fromEntries(presets.map((preset) => [preset.title, preset])),
  );

  return (
    <StyledDropdown
      values={Object.keys(presetsMap)}
      onChanged={(value) => {
        handlePresetChanged(presetsMap[value]);
      }}
      currentValue={selectedPreset.title}
    />
  );
};

export default QualityPresetDropdown;
